<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>

<style lang="scss">
// CoreUI Icons Set
// @import "~@coreui/icons/css/coreui-icons.min.css";
@import '@coreui/coreui/dist/css/coreui.min.css';
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
@import "../src/assets/scss/el-ui.scss";

//add new

@import "../node_modules/toastr/build/toastr.css";
@import "../node_modules/element-ui/lib/theme-chalk/index.css";
@import "../src/assets/scss/ladda.min.css";
@import "../src/assets/fontawesome/css/all.css";

body {
  font-family: var(--font-family-regular);
  font-size: var(--font-size);
}
</style>
